import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { Button, Col, Form, Row } from "react-bootstrap";

import { API } from "../utils/api";
import {
  convertAvailabiltyArr,
  convertTimeTo12h,
  formatSpotPrice,
  isFlatRateSpot,
  showToast,
} from "../utils/helper";
import { trackEvent } from "../utils/analytics";
import { GOOGLE_API_KEY } from "../utils/env";
import { customTimesFilters, timeFilters } from "../Constants";

import { useSelector } from "react-redux";

const SpotDetails = ({ title, item, onClose = null }) => {
  const params = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const spotId = item ? item.id : params.spotId ? params.spotId : "";

  const [data, setData] = useState({});
  const [spot, setSpotData] = useState({
    address: "",
  });

  const [availability, setAvailabillity] = useState([]);
  const [spotMarker, setSpotMarker] = useState({
    lat: 38.905778525393636,
    lng: -77.01938252900719,
  });
  const [location, setLocation] = useState(null);
  const mapRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_API_KEY,
    libraries: ["places"],
  });

  const getSpotDetails = useCallback(() => {
    if (spotId) {
      console.log("SPot Id", spotId);

      API.getSingleSpot(spotId)
        .then((res) => {
          if (res.type === "success") {
            //
            setSpotData({ ...res.data });
            setData({
              ...data,
              price: res.data.ratePerHour,
            });

            if (res.data.location && res.data.location.coordinates) {
              setSpotMarker({
                lat: res.data.location.coordinates[1],
                lng: res.data.location.coordinates[0],
              });
            }

            setAvailabillity(res.data.availabilities);
          }
        })
        .catch((err) => {
          //
          showToast(`ERR : ${err.message}`);
        });
    } else {
      showToast(`ERR : spot id is missing , ${spotId}`);
    }
  }, [spotId]);

  useEffect(() => {
    setData({
      ...data,
      arrivalTime: "",
      timeFrame:
        data.type === "normal"
          ? timeFilters[0].value
          : customTimesFilters[0].value,
    });
  }, [data.type]);

  useEffect(() => {
    getSpotDetails();
  }, []);

  let increments;
  if (data.type === "normal") {
    increments = timeFilters.filter((item) => item.value === data.timeFrame);
  } else {
    increments = customTimesFilters.filter(
      (item) => item.value === data.timeFrame
    );
  }

  const homeLink =
    isAuthenticated && user.type === "admin" ? "/admin/spots" : "user/spots";

  return (
    <div className="spot-details-container">
      <div className="map-container">
        <div className="container">
          <div className="map-heading">
            {title && <h4>{title}</h4>}
            {!title && (
              <span
                className="home-icon asLink"
                onClick={() => navigate(homeLink)}
              >
                <i className="fas fa-home" />
              </span>
            )}

            {onClose && (
              <span className="home-icon asLink" onClick={onClose}>
                <i className="fas fa-times" />
              </span>
            )}
          </div>

          <div className="map-wrapper">
            {isLoaded && spot && (
              <GoogleMap
                ref={mapRef}
                mapContainerStyle={{ width: "100%", height: 250 }}
                center={spotMarker}
                zoom={12}
                // onUnmount={onUnmount}
              >
                {spotMarker && spotMarker.lat !== 0 && (
                  <Marker position={spotMarker} />
                )}
              </GoogleMap>
            )}
          </div>
        </div>
      </div>

      <div className="container">
        <div className="spot-details">
          <div className="spot-details-wrapper" style={{ marginTop: 0 }}>
            <div className="spot-heading-w">
              <Row>
                <Col>
                  <span className="spot-title">
                    {spot.name ? spot.name : ""}
                  </span>
                </Col>
                <Col>
                  {(spot.ratePerHour || isFlatRateSpot(spot)) && (
                    <p className="text-right">{formatSpotPrice(spot)}</p>
                  )}
                </Col>
              </Row>
            </div>

            <div className="spot-heading-w">
              <span className="spot-title">Address</span>
              <p>{spot.address ? spot.address : ""}</p>
            </div>

            {spot.hasEvCharger && (
              <div className="spot-heading-w">
                <span className="ev-charger-badge">
                  <i className="fas fa-bolt me-1" />
                  EV charger available
                </span>
              </div>
            )}

            {availability.length && (
              <div className="">
                <span className="spot-title">Availability</span>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Day</th>
                      <th>Time</th>
                    </tr>
                  </thead>

                  <tbody>
                    {availability.length > 0 &&
                      availability.map((availItem) => {
                        return (
                          <tr key={`${availItem.day}`}>
                            <td>{availItem.day}</td>
                            <td>{`${convertTimeTo12h(
                              availItem.startTime
                            )} - ${convertTimeTo12h(availItem.endTime)}`}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* <div className="arrival-time-text">Arrived at 12:15 PM</div> */}

          <div className="button-wrapper">
            <Button
              className="btn-primary"
              onClick={() => {
                trackEvent("web_book_now_click", { spot_id: spotId });
                navigate(`/booking/${spotId}`);
              }}
            >
              <span>Book Now</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpotDetails;
